import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import { Portlet, Col, Row, Button, Form } from '_zari/core'

import * as FormGroups from './formGroups'
import * as Modals from './modals'

import * as BackgroundJobsService from 'services/backgroundJobs.service'

const portletBreadcrumbs = [{ name: 'Mayorizacion' }]

const MainForm = () => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const [mostrarDetallesDiferenciaTCModal, setMostrarDetallesDiferenciaTCModal] = React.useState(false)

  const formInitialValues = React.useMemo(() => {
    return {
      desdeMes: __adminContext.mesTrabajo,
      hastaMes: __adminContext.mesTrabajo
    }
  }, [__adminContext.mesTrabajo])

  const onSubmit = (formData, { setSubmitting }) => {
    BackgroundJobsService.iniciarMayorizacion(formData)
      .then(() => {
        __zariContext.snack('info', 'Mayorizacion enviada a procesos en background.')
      })
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'No se pudo iniciar el proceso.'))
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <>
      {__adminContext.mesTrabajo && (
        <Portlet>
          <Portlet.Header title='Mayorizacion' breadcrumbs={portletBreadcrumbs} />
          <Portlet.Body>
            <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
              {({ isSubmitting, touched, errors, handleSubmit }) => (
                <>
                  <Form>
                    <FormGroups.MesContabilidadFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.desdeMes}
                      iTouched={touched.desdeMes}
                      idFormato='mayorizacion'
                      label='DESDE'
                      name='desdeMes'
                    />
                    <FormGroups.MesContabilidadFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.hastaMes}
                      iTouched={touched.hastaMes}
                      idFormato='mayorizacion'
                      label='HASTA'
                      name='hastaMes'
                    />
                  </Form>
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button onClick={handleSubmit}>Iniciar Mayorizacion</Button>
                      <Button onClick={() => setMostrarDetallesDiferenciaTCModal(true)}>Verificar Tipos Cambio</Button>
                    </Col>
                  </Row>
                </>
              )}
            </Formik>
          </Portlet.Body>
        </Portlet>
      )}
      {mostrarDetallesDiferenciaTCModal && (
        <Modals.DetallesTcDiferentesModal show={mostrarDetallesDiferenciaTCModal} handleClose={() => setMostrarDetallesDiferenciaTCModal(false)} />
      )}
    </>
  )
}

export default React.memo(MainForm)
